import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { FilterRequest, PagedResponse, ActivityType } from '@core/api';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class ActivityTypeService {
  constructor(private http: HttpClient) { }

  list(request?: FilterRequest): Observable<PagedResponse<ActivityType>> {
    return this.http.post<PagedResponse<ActivityType>>(environment.apiUrl + '/api/ActivityType/List', request);
  }
}
